// emergencyAlertActions.js

export const SHOW_EMERGENCY_ALERT = "SHOW_EMERGENCY_ALERT";
export const HIDE_EMERGENCY_ALERT = "HIDE_EMERGENCY_ALERT";
export const CLEAR_EMERGENCY_ALERTS = "CLEAR_EMERGENCY_ALERTS";

// Action creators
export const showEmergencyAlert = (alert) => ({
  type: SHOW_EMERGENCY_ALERT,
  payload: {
    id: alert.id || `emergency-${Date.now()}`,
    type: alert.type, // 'low', 'medium', 'high'
    alertType: alert.alertType, // e.g., 'System Maintenance', 'Security Alert', 'Data Breach'
    data: alert.data,
    timestamp: new Date().toISOString(),
  },
});

export const hideEmergencyAlert = (id) => ({
  type: HIDE_EMERGENCY_ALERT,
  payload: id,
});

export const clearEmergencyAlerts = () => ({
  type: CLEAR_EMERGENCY_ALERTS,
});

